var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_8814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0665 0.774414H-1.06686C-2.24507 0.774414 -3.2002 1.72954 -3.2002 2.90775V14.6411C-3.2002 15.8193 -2.24507 16.7744 -1.06686 16.7744H17.0665C18.2447 16.7744 19.1998 15.8193 19.1998 14.6411V2.90775C19.1998 1.72954 18.2447 0.774414 17.0665 0.774414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.2002 11.4411H19.1998V16.7744H-3.2002V11.4411ZM-3.2002 0.774414H19.1998V6.10775H-3.2002V0.774414Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_8814"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.77441C0 4.35614 3.58172 0.774414 8 0.774414C12.4183 0.774414 16 4.35614 16 8.77441C16 13.1927 12.4183 16.7744 8 16.7744C3.58172 16.7744 0 13.1927 0 8.77441Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustria);
export default __webpack_public_path__ + "static/media/austria.00ffb57510ffec663dfdaa32ecbea500.svg";
export { ForwardRef as ReactComponent };